var _rect, _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    fill: "url(#pattern0)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 14
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    fill: "url(#pattern1)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0833333 0.0714286)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0833333 0.0714286)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 12,
    height: 14,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAABdmlDQ1BJQ0MgUHJvZmlsZQAAeJx1kTtLA0EUhT8TRUkUBS1ELFJEsUhAFMRSY5EmSIgRfDXJmk2EZF12N0iwFWwsAhaija/Cf6CtYKsgCIogIv4EX42E9U5WiIjOMns/zsy5zJwBX6KolezmYSgZjpWKx0Jz8wuh1mcC+AjSRUdGs83JZDLBv+PjliZVb6Kq1//7/hzB5ZytQVOb8JhmWo7whHBizTEVbwn3aIXMsvCBcMSSAwpfKj3r8ZPivMdviq10agp8qmco/4OzP1grWCXhIeFwqVjWvs+jbtKeM2ZnpPbJ7McmRZwYIbKUWaGIQ1SqIZn97Ruu+6ZZFY8mf5MKljjyFMQbEbUsXXNSddFz8hWpqNx/52nroyNe9/YYtDy67usAtG5Dreq6n4euWzsC/wOcGw3/quQ0/i56taGF96FzA04vGlp2B842offezFiZuuSX6dN1eDmBjnnovobAopfV9zrHd5Belye6gt09GJT9nUtfdP9nyilEJh0AAAC9SURBVHicjdExbsJQEATQZ+IIF5HokSBHSMcNUnIGGiokCsRNOA4tfZTkBqkoqFyAkBA2BWuwEhR7pNH/2p1Z7Z/PHZ8Y+YtR9ECKPt7xhhkGvwzj6E2whm+ULfmV4IzOg1UeoUixxxNODeLnGK7AHN1o9Gqi6t4NTdFBgg8MsUGOVTCP2jA0SRoTMrwE1U61elYVSkwb9heaskqn6cE3Tds4b6gMuxbaHdeEDjjip8HwKqJfYuv6gf9xi8UFYhQy7UPBvA0AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.76ab178e7dd6d2ff6d4780ecdc8c5abc.svg";
export { ForwardRef as ReactComponent };